import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import moment from 'moment';
import { Subject, of } from 'rxjs';

@Injectable()
export class CacheService {

    memoryCache: { [key: string]: any } = {}; // Tipado explícito para memoryCache
    timeCache = 30;

    className = 'CacheService';

    constructor() { }

    canUseCache(key: string, params?: any[]): boolean {
        const name = this.formatName(key, params);

        if (!_.get(this.memoryCache, name)) {
            _.set(this.memoryCache, name, { data: null, lastReqDate: null });
        }

        const oldDate = _.get(this.memoryCache, `${name}.lastReqDate`);
        const canUse = moment().diff(oldDate, 'minutes') <= this.timeCache;

        return canUse;
    }

    getCacheData(key: string, params?: any[]) {
        const name = this.formatName(key, params);
        const cachedData = _.get(this.memoryCache, `${name}.data`);

        return cachedData ? of(cachedData) : _.get(this.memoryCache, `${name}.observer`);
    }

    updateCacheData(data: any, key: string, params?: any[]) {
        const name = this.formatName(key, params);

        _.set(this.memoryCache, `${name}.data`, data);

        if (!_.get(this.memoryCache, `${name}._subject`)) {
            const _subject = new Subject<any>();
            _.set(this.memoryCache, `${name}._subject`, _subject);
        }

        const subject = _.get(this.memoryCache, `${name}._subject`);
        if (subject) {
            subject.next(data);
        } else {
            console.error('Subject is undefined');
        }
    }

    updateCacheReq(key: string, params?: any[]) {
        const name = this.formatName(key, params);
        const _subject = new Subject<any>();
        const observer = _subject.asObservable();

        _.set(this.memoryCache, name, { observer, _subject, lastReqDate: moment() });
    }

    deleteCache(key: string) {
        const keys = _.filter(_.keysIn(this.memoryCache), (prop) => prop.indexOf(key) !== -1);

        if (keys && keys.length > 0) {
            _.forEach(keys, (name: string) => {
                delete this.memoryCache[name];
            });
        }
    }

    formatName(key: string, params?: any[]): string {
        let name = `${key}`;

        if (params) {
            name = `${key}_` + _.join(params, '_');
        }

        return name;
    }
}